import * as React from 'react';

const AngryFace48 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 48 48", width: 48, height: 48, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 24.004c0-11.05 8.95-20 20-20s20 8.95 20 20-8.95 20-20 20-20-8.95-20-20Zm1.5 0c0 10.2 8.3 18.5 18.5 18.5s18.5-8.3 18.5-18.5-8.3-18.5-18.5-18.5-18.5 8.3-18.5 18.5Zm10.59 2.71 4.82 4.34 5.32-4.79 5.82 5.24-1.01 1.11-4.81-4.33-5.32 4.78-5.82-5.24 1-1.11Zm.026-9.107-1.061 1.06 2.857 2.857 1.06-1.06-2.856-2.857Zm15.756 0 1.06 1.06-2.857 2.857-1.06-1.06 2.857-2.857Z",
    clipRule: "evenodd"
  }
));
AngryFace48.Size = 48;
AngryFace48.Title = "AngryFace";

export { AngryFace48 as default };
